/* tslint:disable */
/* eslint-disable */
/**
 * Navitia API - SNCF
 * Complete API documentation for Navitia/SNCF public transportation API. Based on https://doc.navitia.io
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '@/client/configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '@/client/common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '@/client/base';
// @ts-ignore
import type { CommercialModesResponse } from '@/client/models';
// @ts-ignore
import type { PhysicalModesResponse } from '@/client/models';
/**
 * TransportModesApi - axios parameter creator
 */
export const TransportModesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get commercial transport modes
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageCommercialModesGet: async (coverage: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverage' is not null or undefined
            assertParamExists('coverageCoverageCommercialModesGet', 'coverage', coverage)
            const localVarPath = `/coverage/{coverage}/commercial_modes`
                .replace(`{${"coverage"}}`, encodeURIComponent(String(coverage)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get physical transport modes
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoveragePhysicalModesGet: async (coverage: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverage' is not null or undefined
            assertParamExists('coverageCoveragePhysicalModesGet', 'coverage', coverage)
            const localVarPath = `/coverage/{coverage}/physical_modes`
                .replace(`{${"coverage"}}`, encodeURIComponent(String(coverage)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TransportModesApi - functional programming interface
 */
export const TransportModesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TransportModesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get commercial transport modes
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverageCoverageCommercialModesGet(coverage: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommercialModesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverageCoverageCommercialModesGet(coverage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransportModesApi.coverageCoverageCommercialModesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get physical transport modes
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverageCoveragePhysicalModesGet(coverage: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PhysicalModesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverageCoveragePhysicalModesGet(coverage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransportModesApi.coverageCoveragePhysicalModesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TransportModesApi - factory interface
 */
export const TransportModesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TransportModesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get commercial transport modes
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageCommercialModesGet(coverage: string, options?: RawAxiosRequestConfig): AxiosPromise<CommercialModesResponse> {
            return localVarFp.coverageCoverageCommercialModesGet(coverage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get physical transport modes
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoveragePhysicalModesGet(coverage: string, options?: RawAxiosRequestConfig): AxiosPromise<PhysicalModesResponse> {
            return localVarFp.coverageCoveragePhysicalModesGet(coverage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TransportModesApi - interface
 */
export interface TransportModesApiInterface {
    /**
     * 
     * @summary Get commercial transport modes
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverageCoverageCommercialModesGet(coverage: string, options?: RawAxiosRequestConfig): AxiosPromise<CommercialModesResponse>;

    /**
     * 
     * @summary Get physical transport modes
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverageCoveragePhysicalModesGet(coverage: string, options?: RawAxiosRequestConfig): AxiosPromise<PhysicalModesResponse>;

}

/**
 * TransportModesApi - object-oriented interface
 */
export class TransportModesApi extends BaseAPI implements TransportModesApiInterface {
    /**
     * 
     * @summary Get commercial transport modes
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverageCoverageCommercialModesGet(coverage: string, options?: RawAxiosRequestConfig) {
        return TransportModesApiFp(this.configuration).coverageCoverageCommercialModesGet(coverage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get physical transport modes
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverageCoveragePhysicalModesGet(coverage: string, options?: RawAxiosRequestConfig) {
        return TransportModesApiFp(this.configuration).coverageCoveragePhysicalModesGet(coverage, options).then((request) => request(this.axios, this.basePath));
    }
}

